import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import {
  AccessUserInfo,
  LabActionItemTabDetail,
  MissingDrawDateActionItem,
  UserDetail,
  UserLocationFacility,
} from "src/app/models";
import { CustomDatePipe } from "src/app/pipes";
import { CustomDialogService, LabActionItemService, UserService } from "src/app/services";
import { LoaderService } from "src/app/services/loader.service";
import { EnterDrawDateComponent } from "../../shipping-manifest/pending-manifest/enter-draw-date/enter-draw-date.component";
import { ShippingManifestData } from "src/app/models/water-lab/shipping-manifest";
import { UserAction } from "src/app/enum/user/userActions";
import { ScreenName, UserActionDescription } from "src/app/enum/user/userActionDescription";
@Component({
  selector: "bart-missing-draw-date",
  templateUrl: "./missing-draw-date.component.html",
  styleUrls: ["./missing-draw-date.component.scss"],
  providers: [DatePipe, CustomDialogService, CustomDatePipe],
})
export class MissingDrawDateComponent implements OnInit {
  @Input() selectedFacilityMasterId: number;
  @Input() userFacilities: UserLocationFacility[];
  @Output() refreshTabCount: EventEmitter<any> = new EventEmitter();
  @Input() tabDetails:LabActionItemTabDetail
  tableColumn: any[];
  missingDrawDateActionItems: MissingDrawDateActionItem[] = [];
  public userDetail: UserDetail;
  constructor(
    private _loaderService: LoaderService,
    private _labActionItemService: LabActionItemService,
    private dialogService: CustomDialogService,
    private customDatePipe: CustomDatePipe,
    private _userService: UserService
  ) {this.userDetail = AccessUserInfo.getUserInfo();}
 
  ngOnInit() {
    this.tableColumn = [
      { field: "LabRequisitionNumber", header: "Requisition ID" },
      {
        field: "EquipmentDisplayName",
        header: "Model # | Nickname | Serial # | Equipment ID",
      },
      {
        field: "ShippingManifestPrintDate",
        header: "Last Shipping Manifest Print Date",
      },
      { field: "PrintLabelDate", header: "Label Print Date" },
    ];
    this.loadMissingDrawDateActionItems();
      //#region User Action Audit
      this._userService.logUserAction({
        userName: this.userDetail.userName,
        userAction: UserAction.FILTER,
        screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
        screenPath: location.pathname,
        key: "FacilityMasterID",
        value: this.selectedFacilityMasterId,
        eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_MISSING_DRAW_DATE_GRID_LOADED
      });
      //#endregion
  }
  loadMissingDrawDateActionItems() {
    let getMissingDrawDateParam = {
      GETMISSINGDRAWDATEACTIONITEMS: {
        FacilityMasterID: this.selectedFacilityMasterId,
      },
    };
    this._loaderService.show();
    this._labActionItemService
      .getMissingDrawDateActionItems(JSON.stringify(getMissingDrawDateParam))
      .subscribe(
        (resp: any) => {
          this.missingDrawDateActionItems = resp.getMissingDrawDateActionItems;
          if (this.missingDrawDateActionItems) {
            this.missingDrawDateActionItems.forEach((item) => {
              item.PrintLabelDate = this.customDatePipe.transform(
                item.PrintLabelDate,
                "local",
                "MM/dd/yyyy HH:mm"
              );
              item.PrintLabelDateSort = new Date(
                this.customDatePipe.transform(
                  item.PrintLabelDate,
                  "local",
                  "MM/dd/yyyy HH:mm"
                )
              );
              item.ShippingManifestPrintDate = this.customDatePipe.transform(
                item.ShippingManifestPrintDate,
                "local",
                "MM/dd/yyyy HH:mm"
              );
              item.ShippingManifestPrintDateSort = new Date(
                this.customDatePipe.transform(
                  item.ShippingManifestPrintDate,
                  "local",
                  "MM/dd/yyyy HH:mm"
                )
              );
              item.DrawDate = this.customDatePipe.transform(
                item.DrawDate,
                "local",
                "MM/dd/yyyy HH:mm"
              );
            });
          }
          if(this.missingDrawDateActionItems && this.tabDetails.RecordCount!=this.missingDrawDateActionItems.length)
          {
            this.tabDetails.RecordCount=this.missingDrawDateActionItems.length
          }
          this._loaderService.hide();
        },
        (error) => {
          this._loaderService.hide();
        }
      );
  }

  EnterActualDrawDate(rowDetails: MissingDrawDateActionItem) {
    const ref = this.dialogService.open(EnterDrawDateComponent, {
      header: "Edit Draw Date",
      width: "55%",
      showHeader: false,
      closeOnEscape: false,
      data: {
        data: [rowDetails],
        isEdit: true,
        workFlow: rowDetails.WorkFlow,
      },
    });
    ref.onClose.subscribe((ref) => {
      if (ref && ref.refresh) {
        this.refreshTabCount.emit();
      }
    });

       //#region User Action Audit
       this._userService.logUserAction({
        userName: this.userDetail.userName,
        userAction: UserAction.BUTTON_CLICKED,
        screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
        screenPath: location.pathname,
        key: 'LabRequisitionID',
        value: rowDetails.LabRequisitionID,
        eventDescription: UserActionDescription.LABREQUEST_ACTION_ITEMS_MISSING_DRAW_DATE_ENTER_DRAW_DATE_CLICKED
      });
      //#endregion
  }
  sortColumn(event) {
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userDetail.userName,
      userAction: UserAction.SORT,
      screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
      screenPath: location.pathname,
      key: event.field,
      value: event.order === 1 ? 'ASC' : 'DESC',
      eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_MISSING_DRAW_DATE_COLUMN_SORT
    });
    //#endregion
  }
paginate(event) {
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userDetail.userName,
      userAction: UserAction.PAGE_CHANGED,
      screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
      screenPath: location.pathname,
      key: 'Selected_Page_No',
      value: (event.first / event.rows) + 1,
      eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_MISSING_DRAW_DATE_PAGE_NO_CLICKED
    });
    //#endregion
  }



}
